var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-wrap" },
    [
      _c(
        "div",
        { staticClass: "login-top" },
        [
          _c("login-top"),
          _c("div", { staticClass: "content-part" }, [
            _c("img", {
              staticClass: "left-logo",
              attrs: {
                src: require("@/assets/img/kcc-logo-encn.png"),
                width: "100%",
              },
            }),
            _c(
              "div",
              { class: _vm.appendLoginFormHeight },
              [
                _c("div", { staticClass: "title-line" }, [
                  _c(
                    "span",
                    {
                      class: [
                        "ms-title",
                        _vm.$i18n.locale === "en" ? "en-lang" : "",
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t("login_welcome_1")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ms-title",
                      class: { "en-lang": _vm.$i18n.locale === "en" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("login_welcome_2")))]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "font-light1" },
                  [
                    _c(
                      "el-steps",
                      {
                        staticClass: "mb_20 zh-last",
                        class: [
                          _vm.$i18n.locale === "en" ? "en-last1" : "zh-last",
                        ],
                        attrs: {
                          simple: "",
                          active: _vm.currentStep,
                          "finish-status": "success",
                        },
                      },
                      [
                        _c(
                          "el-step",
                          { staticClass: "step-name" },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c("span", { staticClass: "mr_4" }, [
                                  _vm._v(_vm._s(_vm.$t("login.step1"))),
                                ]),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      content: _vm.$t("login_step1_tip"),
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-question" })]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "circle-group",
                                    class: { en: _vm.$i18n.locale === "en" },
                                  },
                                  [
                                    _c("span", { staticClass: "big-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "step-arrow" }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _c(
                          "el-step",
                          {
                            staticClass: "step-name",
                            class: { "step-number": _vm.currentStep === 1 },
                            attrs: { title: _vm.$t("login.step2") },
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _vm.currentStep === 1
                                  ? _c("svg-icon", {
                                      staticClass: "mr_4",
                                      attrs: {
                                        "icon-name": "numberTwo",
                                        size: "17",
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "mr_4" }, [
                                  _vm._v(_vm._s(_vm.$t("login.step2"))),
                                ]),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("div", {
                                      attrs: { slot: "content" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("login_step2_tip")
                                        ),
                                      },
                                      slot: "content",
                                    }),
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                    }),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "circle-group",
                                    class: { en: _vm.$i18n.locale === "en" },
                                  },
                                  [
                                    _c("span", { staticClass: "big-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "small-circle" }),
                                    _c("span", { staticClass: "step-arrow" }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _c(
                          "el-step",
                          {
                            staticClass: "step-name step3",
                            class: [
                              { "step-number": _vm.currentStep < 3 },
                              { "left-20": _vm.$i18n.locale === "en" },
                            ],
                            attrs: { title: _vm.$t("login.step3") },
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _vm.currentStep < 3
                                  ? _c("svg-icon", {
                                      staticClass: "mr_4",
                                      attrs: {
                                        "icon-name": "numberThree",
                                        size: "17",
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "mr_4" }, [
                                  _vm._v(_vm._s(_vm.$t("login.step3"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.currentStep === 3
                  ? _c(
                      "el-tabs",
                      {
                        staticClass: "cust-tabs",
                        attrs: { type: "border-card" },
                        on: { "tab-click": _vm.handleTabClick },
                        model: {
                          value: _vm.param.verificationCodeType,
                          callback: function ($$v) {
                            _vm.$set(_vm.param, "verificationCodeType", $$v)
                          },
                          expression: "param.verificationCodeType",
                        },
                      },
                      _vm._l(_vm.tabs, function (tab) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: tab.code,
                            attrs: { name: tab.code, label: tab.name },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "tab-label",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("SvgIcon", {
                                  staticClass: "way-icon",
                                  attrs: {
                                    "icon-name": tab.icon,
                                    size: "20",
                                    "icon-color":
                                      _vm.param.verificationCodeType ===
                                      tab.code
                                        ? "#005eb8"
                                        : "rgb(38 47 63)",
                                  },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(tab.name)) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form",
                  {
                    ref: "login",
                    staticClass: "ms-content login-form",
                    attrs: {
                      model: _vm.param,
                      rules: _vm.rules,
                      "label-width": "0px",
                      onsubmit: "return false",
                    },
                  },
                  [
                    _vm.currentStep === 1
                      ? [
                          _c(
                            "el-form-item",
                            {
                              class: _vm.accountFlag
                                ? "item checkAccount"
                                : "item checkAccount is-error",
                              staticStyle: { "margin-bottom": "18px" },
                              attrs: { prop: "account" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.accountFocus || _vm.param.account
                                      ? "label label-active"
                                      : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.accountInput.focus()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.forgotAccount")))]
                              ),
                              _c("el-input", {
                                ref: "accountInput",
                                staticClass: "right-btn-item",
                                on: {
                                  blur: function ($event) {
                                    _vm.accountFocus = false
                                  },
                                  focus: _vm.focusAccount,
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.next.apply(null, arguments)
                                  },
                                },
                                model: {
                                  value: _vm.param.account,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.param, "account", $$v)
                                  },
                                  expression: "param.account",
                                },
                              }),
                              !_vm.accountFlag
                                ? _c(
                                    "div",
                                    { staticClass: "el-form-item__error" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errorMsgShow) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm.currentStep === 2
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item",
                              attrs: { prop: "password" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.pwdFocus || _vm.param.password
                                      ? "label label-active"
                                      : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.pwdInput.focus()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login_passWorld")))]
                              ),
                              _c("el-input", {
                                ref: "pwdInput",
                                attrs: { "show-password": "" },
                                on: {
                                  blur: function ($event) {
                                    _vm.pwdFocus = false
                                  },
                                  focus: function ($event) {
                                    _vm.pwdFocus = true
                                  },
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.next.apply(null, arguments)
                                  },
                                },
                                model: {
                                  value: _vm.param.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.param, "password", $$v)
                                  },
                                  expression: "param.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : [
                          _vm.param.verificationCodeType === "EMAIL"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "mb_40 item checkAccount",
                                  attrs: { prop: "account" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: _vm.param.account
                                        ? "label label-disabled-active"
                                        : "label",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login_account")))]
                                  ),
                                  _c("el-input", {
                                    ref: "loginAccountInput",
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.param.account,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.param, "account", $$v)
                                      },
                                      expression: "param.account",
                                    },
                                  }),
                                  !_vm.accountFlag
                                    ? _c(
                                        "div",
                                        { staticClass: "el-form-item__error" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.errorMsgShow) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  staticClass: "item code-item mb_40",
                                  class: _vm.phoneFlag
                                    ? "item checkAccount"
                                    : "item checkAccount is-error",
                                  attrs: { prop: "receiverNumber" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "label label-active",
                                      class: {
                                        "label-disabled-active":
                                          _vm.phoneDisabled,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.$refs.phoneInput.focus()
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.phone")))]
                                  ),
                                  _c(
                                    "el-input",
                                    {
                                      ref: "phoneInput",
                                      staticClass: "phone-input",
                                      class: [
                                        "right-btn-item",
                                        _vm.codeBtn ? "code_disabled" : "",
                                      ],
                                      attrs: {
                                        placeholder: _vm.$t("login.phone"),
                                        disabled: _vm.phoneDisabled,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.param.receiverNumber =
                                            _vm.param.receiverNumber.trim()
                                        },
                                        blur: _vm.handlePhoneBlur,
                                        focus: () => {
                                          _vm.phoneFocus = true
                                          _vm.phoneFlag = true
                                        },
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.submitForm()
                                        },
                                      },
                                      model: {
                                        value: _vm.param.receiverNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.param,
                                            "receiverNumber",
                                            $$v
                                          )
                                        },
                                        expression: "param.receiverNumber",
                                      },
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "prepend" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass:
                                                "phone-prepend left-btn-item",
                                              class: {
                                                "zh-width":
                                                  _vm.$i18n.locale === "zh",
                                              },
                                              attrs: {
                                                slot: "prepend",
                                                disabled: _vm.phoneDisabled,
                                                placeholder: "请选择",
                                              },
                                              slot: "prepend",
                                              model: {
                                                value: _vm.regionPhone,
                                                callback: function ($$v) {
                                                  _vm.regionPhone = $$v
                                                },
                                                expression: "regionPhone",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("login.china"),
                                                  value: "+86",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    _vm.$t("login.HongKong"),
                                                  value: "+852",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("login.Macau"),
                                                  value: "+853",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                  !_vm.phoneFlag
                                    ? _c(
                                        "div",
                                        { staticClass: "el-form-item__error" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.errorMsgShow) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item code-item",
                              attrs: { prop: "verificationCode" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: _vm.codeFocus
                                    ? "label label-active"
                                    : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.codeInput.focus()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("login_verification_Code"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  ref: "codeInput",
                                  class: [
                                    "right-btn-item",
                                    _vm.codeBtn ? "code_disabled" : "",
                                  ],
                                  on: {
                                    focus: function ($event) {
                                      _vm.codeFocus = true
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submitForm()
                                    },
                                  },
                                  model: {
                                    value: _vm.param.verificationCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.param,
                                        "verificationCode",
                                        $$v
                                      )
                                    },
                                    expression: "param.verificationCode",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "login-btn",
                                          attrs: {
                                            disabled: _vm.codeBtn,
                                            loading: _vm.codeLoading,
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getCode()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getCodeSecond > 0
                                                  ? `${_vm.getCodeSecond} s`
                                                  : _vm.$t("login_btn_getCode")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "footer-login" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "login-item",
                                  attrs: {
                                    loading: _vm.loginLoading,
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("login_btn_login")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.firstLogin,
                                  expression: "firstLogin",
                                },
                              ],
                              attrs: { prop: "termOfUse" },
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.param.termOfUse,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.param, "termOfUse", $$v)
                                    },
                                    expression: "param.termOfUse",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "login-terms-font",
                                      staticStyle: { color: "#584d4d" },
                                    },
                                    [
                                      _c("el-checkbox", {
                                        staticStyle: { "padding-right": "4px" },
                                        attrs: { name: "termOfUse" },
                                      }),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.$t("login_read_terms")) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              "text-decoration": "underline",
                                              color: "#00338d",
                                            },
                                            attrs: {
                                              href: "javascript:void 0;",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateToTermOfUse()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("login_terms"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    和\n                    "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              "text-decoration": "underline",
                                              color: "#00338d",
                                            },
                                            attrs: {
                                              href: "javascript:void 0;",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateToPerson()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("person_info_collect")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
                _vm.currentStep === 2
                  ? _c("p", { staticClass: "login-tips" }, [
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: { click: _vm.goTo },
                        },
                        [_vm._v(_vm._s(_vm.$t("login_forget")) + "?")]
                      ),
                    ])
                  : _vm._e(),
                _vm.currentStep !== 3
                  ? _c(
                      "el-button",
                      {
                        staticClass: "next-btn",
                        attrs: { loading: _vm.btnLoading, type: "primary" },
                        on: { click: _vm.next },
                      },
                      [_vm._v(_vm._s(_vm.nextLabel))]
                    )
                  : _vm._e(),
                _vm.supportShow && false
                  ? _c(
                      "el-popover",
                      {
                        staticClass: "manual-text2",
                        attrs: {
                          placement: "top-start",
                          width: "400",
                          trigger: "hover",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "white-space": "pre-wrap",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("manual2")))]
                        ),
                        _c(
                          "pre",
                          {
                            staticClass: "help",
                            attrs: { slot: "reference" },
                            on: { click: _vm.toogleSupportVisible },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(_vm.$t("help_tip")))]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "manual-text2" }, [
                  _vm.supportShow
                    ? _c(
                        "a",
                        {
                          attrs: {
                            target: "_top",
                            href: "mailto:cnfmkpmgclicbt@kpmg.com",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("help_tip")))]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("v-bottom"),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "毕马威智联平台使用条款",
            visible: _vm.cnDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cnDialogVisible = $event
            },
          },
        },
        [
          _vm._v(
            "\n    本使用条款规范了您对毕马威智联平台的访问和使用。\n    "
          ),
          _c(
            "ul",
            { staticStyle: { "list-style": "decimal", padding: "0 20px" } },
            [
              _c("li", [
                _vm._v("您对毕马威智联平台的免费访问和使用应遵守本使用条款。"),
              ]),
              _c("li", [
                _vm._v(
                  "毕马威智联平台站点上的数据将被存储于位于中国上海的服务器中。"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "毕马威向您授予非排他、免费、受限和可撤销的许可仅为服务之目的访问和使用毕马威智联平台以及该平台上由毕马威和/或任何毕马威全球性组织中的任何成员所或其代表不定期发布的内容（以下称“毕马威内容”）。"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "您保证作为授权用户（“授权用户”）遵守本使用条款。您点击接受本使用条款构成您遵守本使用条款的承诺。"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "您认可：与毕马威智联平台有关的所有知识产权均由毕马威或其许可方所有，且您在毕马威智联平台上或其中不享有任何类型的权利或权益。您进一步认可毕马威内容可能是机密的，您同意尊重该等内容的保密性。"
                ),
              ]),
              _c("li", [
                _vm._v("\n        您不得：\n        "),
                _c(
                  "ul",
                  {
                    staticClass: "sub-list",
                    staticStyle: { "list-style": "none" },
                  },
                  [
                    _c("li", { attrs: { "data-index": "a) " } }, [
                      _vm._v(
                        "\n            在身处中国内地之外的任何地方时访问和/或使用毕马威智联平台（本条仅适用于授权用户是中国内地企业的雇员）；\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "b) " } }, [
                      _vm._v(
                        "\n            允许任何第三方访问或使用毕马威智联平台，或代表任何第三方使用该平台（包括但不限于代表任何第三方运营任何形式的设施或运营软件服务或类似服务），除非本使用条款另有明确许可；\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "c) " } }, [
                      _vm._v(
                        "从毕马威智联平台处复制、翻译、修改、适配或创建衍生作品；"
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "d) " } }, [
                      _vm._v(
                        "创建至毕马威智联平台或任何毕马威内容的互联网链接，或将任何毕马威内容嵌入或映射至任何其他服务器及无线或互联网设备；"
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "e) " } }, [
                      _vm._v(
                        "\n            尝试探寻或查看毕马威智联平台的源代码，或对该平台所使用的软件进行反向工程、修改、解密、提取、分解或反编译（除非您依法有权进行该等操作，且毕马威依法不得限制或防止该等操作，但您应及时提前通知毕马威您意图此举）；\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "f) " } }, [
                      _vm._v(
                        "\n            尝试干预毕马威智联平台的正常工作，尤其不得尝试绕过安全、许可证控制或其他保护机制，或篡改、入侵或以其他方式破坏该平台或其任何相关网站、计算机系统、服务器、路由器或任何互联网设备；\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "g) " } }, [
                      _vm._v(
                        "在毕马威智联平台操作或使用过程中遮挡、修改或删除该平台上标明的或显示的任何版权声明、商标或其他所有权标识；或"
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "h) " } }, [
                      _vm._v(
                        "\n            通过毕马威智联平台上传、存储、发布、通过电子邮件发送、传输或实施其他手段提供任何侵犯他人的知识产权、数据保护、隐私或其他权利的内容，任何诽谤性或违反任何合同义务或保密义务的内容，任何淫秽、色情、威胁性、煽动暴力或仇恨、侮辱性、歧视性（不论出于何种理由）的内容，或违反适用法律法规或无权合法上传的内容（以下称“禁止内容”）；\n          "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        您同意遵守毕马威不定期知会您的与使用毕马威智联平台相关的所有毕马威政策，包括安全、科技和风险管理政策、规定和指引。若您不同意新的或变更后的政策，则应立刻书面通知毕马威，毕马威可自行决定终止您使用毕马威智联平台的权限。您还同意当发现任何可能损害毕马威智联平台的安全事件或行为（例如授权用户密码被非法使用）时，及时书面通知毕马威。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        您承认尽管毕马威在设计毕马威智联平台时考虑了信息安全，并已采取措施通过该平台的在线隐私声明中所述的手段保护该平台的安全性，但是毕马威无法保证该平台不受黑客或其他非法第三方访问的影响。您也承认通过互联网传输信息并非完全安全，始终有可能会被第三方非法截获。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        毕马威不保证毕马威智联平台上发布的任何内容不含病毒和/或其他可能含有污染性或破坏性元素的代码。您应负责采取适当的信息技术安全防护手段（包括反病毒和其他安全检查），以满足您对自身通过该平台提供和访问的内容的安全性和可靠性的具体要求。毕马威不对该平台上可能提供的任何第三方网站的内容和超链接的内容承担责任。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        带宽、网络配置、计算机浏览器设置等技术因素均可能影响毕马威智联平台的速度和可用性。毕马威不保证该平台能够持续、无中断或无错误地运行，也不保证其与您的计算机浏览器或与您的计算机系统的任何其他部分的兼容性。您同意毕马威智联平台的访问可能会随时暂停、受限、被拒绝或关闭，并同意发布在该平台上的内容可能无法恢复。您作为授权用户应确保留存发布在平台上的所有内容的副本。毕马威不负责为您恢复或向您提供该平台上发布的任何内容。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        若因您违反本使用条款规定的任何义务使毕马威或其他毕马威成员所（分别及统称为“毕马威一方”）遭受第三方的任何索赔申诉或索赔威胁（包括与您发布禁止内容相关的索赔），您应对毕马威一方作出赔偿，保护毕马威一方不受伤害，并补偿和保护毕马威一方使任何毕马威一方免受因任何该等违反及索赔而造成的损失、损害、费用或责任。本条款中，“您”包括所有授权用户，而“毕马威一方”包括毕马威一方的各位及所有合伙人、成员、总监、雇员、代理商，以及受毕马威一方控制或与毕马威一方相关联的任何实体。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        您应对您在毕马威智联平台及该平台上发布的内容的所有使用自行承担责任。除非本使用条款中另有明确规定外，不存在适用于毕马威智联平台或任何毕马威内容的默示担保、保证或其他条款。本使用条款未限制或排除毕马威应承担因其重大过失或欺诈性不实陈述所导致的人员伤亡或财产损失的责任，或适用法律不得限制或排除的任何其他责任。在不违反本条前述规定的前提下，毕马威无论在何种情况下均不应对您的任何间接或后果性损失负责，也不对您的任何利润、收入、合同、数据、商誉或其他类似损失负责。由本使用条款导致或与其相关的毕马威的责任构成双方合同项下的责任的一部分，并受与该合同项下的责任相关条款约束，本文另有明确规定除外。\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        一旦服务无论因何种原因终止，您应立刻停止访问和使用毕马威智联平台，毕马威可去活或删除相关用户账户，除非适用法律或专业标准另有保留此类账户的要求。毕马威保留出于任何原因终止您访问毕马威智联平台的权利，包括但不限于若发现您未经授权使用该平台或违反本使用条款。\n      "
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "KPMG Collaboration Centre Terms of Use",
            visible: _vm.enDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.enDialogVisible = $event
            },
          },
        },
        [
          _c(
            "ul",
            {
              staticStyle: {
                "list-style": "decimal",
                padding: "0 20px",
                "word-break": "normal",
                "overflow-wrap": "break-word",
              },
            },
            [
              _vm._v(
                "\n      These Terms of Use govern the access to, and usage of, KPMG Collaboration Centre (“KCC”) by you.\n      "
              ),
              _c("li", [
                _vm._v(
                  "Access to and use of KCC on a complimentary basis is subject to these Terms of Use."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "Data located in the KCC site will be stored on a server in China."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "KPMG grants to you a non-exclusive, royalty-free, limited and revocable license to access and use KCC and\n        the\n        content posted on it from time to time by or on behalf of KPMG and/or any of the member firms of the KPMG\n        global\n        organization of independent firms (“KPMG Content”), solely for the purpose of services."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "You warrant that as an authorised user (“Authorized User”), you will comply with these Terms of Use. By\n        clicking\n        the acceptance button for these Terms of Use, this shall constitute your commitment to comply with these Terms\n        of\n        Use in its entirety."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "You acknowledge that all intellectual property rights pertaining to KCC are owned by KPMG or its licensors\n        and\n        that you acquire no right or interest of any kind in or to KCC. You further acknowledge that KPMG Content may\n        be\n        confidential, and you agree to respect the confidentiality of such content."
                ),
              ]),
              _c("li", [
                _vm._v("\n        You will not:\n        "),
                _c(
                  "ul",
                  {
                    staticClass: "sub-list",
                    staticStyle: { "list-style": "none" },
                  },
                  [
                    _c("li", { attrs: { "data-index": "a)" } }, [
                      _vm._v(
                        "\n            access and/or use KCC when you are outside the territory of mainland China (this restriction only applies\n            to\n            the Authorised User is an employee of an entity incorporated in mainland China);\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "b) " } }, [
                      _vm._v(
                        "\n            except as expressly permitted by these Terms of Use, permit any third party to access or use KCC or use it\n            on\n            behalf of any third party (which includes without limitation operating any form of facility on behalf of\n            any\n            third party or operating a software bureau or similar service);\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "c) " } }, [
                      _vm._v(
                        "copy, translate, modify, adapt or create derivative works from KCC;"
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "d) " } }, [
                      _vm._v(
                        '\n            create internet "links" to KCC or any KPMG content, or "frame" or "mirror" any KPMG Content on any other\n            server or wireless or Internet-based device;\n          '
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "e) " } }, [
                      _vm._v(
                        "\n            attempt to discover or gain access to the source code for KCC or reverse engineer, modify, decrypt,\n            extract,\n            disassemble or decompile the software it employs (except to the extent that you are permitted to do so\n            under\n            applicable law in circumstances under which KPMG is not lawfully entitled to restrict or prevent the same,\n            provided KPMG is given prompt advance notice of your intention to do so);\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "f) " } }, [
                      _vm._v(
                        "\n            attempt to interfere with the proper working of KCC and, in particular, must not attempt to circumvent\n            security, license control or other protection mechanisms, or tamper with, hack into or otherwise disrupt\n            KCC\n            or any associated website, computer system, server, router or any other internet-connected device;\n          "
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "g) " } }, [
                      _vm._v(
                        "obscure, amend or remove any copyright notice, trademark or other proprietary marking\n            on,\n            or visible during the operation or use of, KCC; or"
                      ),
                    ]),
                    _c("li", { attrs: { "data-index": "h) " } }, [
                      _vm._v(
                        "\n            use KCC to upload, store, post, email, transmit or otherwise make available any content that infringes any\n            intellectual property rights or data protection, privacy or other rights of any other person, is\n            defamatory or\n            in breach of any contractual duty or any obligation of confidence, is obscene, sexually explicit,\n            threatening,\n            inciteful of violence or hatred, blasphemous, discriminatory (on any ground), or that does not comply with\n            all\n            applicable laws and regulations or not lawfully entitled to be uploaded (“Prohibited Content”).\n          "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        You agree to comply with all KPMG policies including security, technology and risk management policies, rules,\n        and\n        guidelines relating to the use of KCC of which KPMG has notified you from time to time. If you do not agree to\n        new\n        or changed policies, then you will immediately advise KPMG in writing and KPMG may, in its sole discretion,\n        terminate your use of KCC. You further agree to promptly notify KPMG in writing if you become aware of any\n        event\n        or action which might reasonably impair KCC’s security, such as improper access to the password of an\n        Authorised\n        User.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        You acknowledge that, whilst KPMG has designed KCC with information security in mind and has taken steps to\n        safeguard the security of KCC by way of the measures described in the KCC online privacy statement, KPMG\n        cannot\n        guarantee that KCC is invulnerable to hacking or other unauthorized access by third parties. You also\n        acknowledge\n        that transmission of information over the Internet is not entirely secure and there is always the possibility\n        of\n        unauthorized interception by third parties.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        KPMG does not guarantee that any content posted on KCC will be free from viruses and/or other code that may\n        have\n        contaminating or destructive elements. It is your responsibility to implement appropriate IT security\n        safeguards\n        (including anti-virus and other security checks) to satisfy its particular requirements as to the safety and\n        reliability of content it provides and accesses through KCC. KPMG accepts no responsibility for the content of\n        any\n        third-party websites and hyperlinks to which may be featured on KCC.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        Technical factors such as bandwidth, network configurations, and computer browser settings can affect KCC’s\n        speed\n        and accessibility. KPMG does not guarantee the continuous, uninterrupted or error-free operability of KCC, or\n        compatibility with your computer browser or any other part of its computing systems. You acknowledge that\n        access\n        to KCC may be suspended, limited, denied or disabled at any time and that content posted on KCC may not be\n        recoverable. You are responsible for ensuring that as an Authorised User, you retain copies of all content\n        posted\n        on KCC. KPMG has no responsibility for recovering or providing to you any content posted on KCC.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        If you breach any of its obligations under these Terms of Use and any claim is made or threatened against\n        either\n        KPMG or other KPMG member firm(s) (individually and collectively “the KPMG Party”) by a third party (including\n        without limitation claims concerning the posting by you of Prohibited Content), you shall compensate the KPMG\n        Party, hold the KPMG Party harmless and reimburse the KPMG Party for and protect the KPMG Party against, any\n        loss,\n        damage, expense or liability incurred by the KPMG Party which results from or arises from or is connected with\n        any\n        such breach and any such claim. In this clause “you” includes all Authorised Users and “the KPMG Party”\n        includes\n        each and all partners, members, directors, employees, agents of the KPMG Party together with any entity\n        controlled\n        by or associated with the KPMG Party.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        You are solely responsible for all use you make of KCC and of the content posted on KCC. Except as expressly\n        set\n        out in these Terms of Use, no implied conditions, warranties or other terms apply to KCC or any KPMG Content.\n        Nothing in these Terms of Use limits or excludes KPMG’s liability for death or property damage caused by its\n        gross\n        negligence or for fraudulent misrepresentation or any other liability that may not, under applicable law, be\n        limited or excluded. Subject to the foregoing, in no event shall KPMG be liable to you for any indirect or\n        consequential losses, or for any loss of profit, revenue, contracts, data, goodwill or other similar losses.\n        KPMG’s liability arising from or in connection with these Terms of Use constitutes part of KPMG’s liability\n        under\n        the agreement concluded between parties and is subject to the relevant provisions concerning liability\n        thereunder\n        if any except for those explicitly provided herein.\n      "
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        Upon the termination of the services for any reason, all further access to and use of KCC by you must\n        immediately\n        cease and KPMG may deactivate or delete related user accounts, unless otherwise required by applicable law or\n        professional standards to maintain such accounts. KPMG reserves the right to terminate your access to KCC for\n        any\n        reason, including without limitation in the event KPMG becomes aware of any unauthorized use of KCC by\n        Authorised\n        Users, or breach by Authorised Users of these Terms of Use.\n      "
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "个人信息收集与处理告知同意书",
            visible: _vm.cnPersonDialogVisible,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cnPersonDialogVisible = $event
            },
          },
        },
        [
          _vm._v(
            "\n    毕马威为帮助您访问KCC*（即毕马威智联平台）及支持您对该平台的使用（ “目的”\n    ）而从贵方获取的个人信息，将由毕马威根据中华人民共和国《个人信息保护法》、中国香港特别行政区《个人资料（私隐）条例》以及澳门特别行政区《个人资料保护法》（统称为 “适用法规” ）以及毕马威的\n    "
          ),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://kpmg.com/cn/zh/home/misc/privacy.html",
                target: "_blank",
              },
            },
            [_vm._v("在线隐私声明")]
          ),
          _vm._v("\n    及"),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://assets.kpmg.com/content/dam/kpmg/cn/pdf/zh/2023/03/kpmg-china-privacy-statement.pdf",
                target: "_blank",
              },
            },
            [_vm._v("毕马威中国隐私声明")]
          ),
          _vm._v(" ( 统称为“隐私声明”) 进行收集、使用、处理及保存。\n    "),
          _c(
            "ul",
            { staticStyle: { "font-style": "italic", padding: "8px 0" } },
            [
              _vm._v(
                "\n      （*本声明适用于KCC的“授权用户”（其定义详见《毕马威智联平台使用条款》；在本声明中未约定的、有关您对KCC的访问及使用的各项事宜，均以《毕马威智联平台使用条款》为准）\n    "
              ),
            ]
          ),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      为上述目的并为遵守适用法规的要求，您在此同意向我方提供以下个人信息：\n    "
            ),
          ]),
          _c(
            "ul",
            { staticStyle: { "list-style": "decimal", padding: "0 20px" } },
            [
              _c("li", [
                _vm._v(
                  "您的以下个人信息，以便毕马威能够为您注册在KCC平台中的用户账户。"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "(a) 您的用户名及工作电子邮箱地址（作为您的KCC登录账户）。"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "(b) 若您同意，您还可以选择提供个人手机号码；该号码仅被用于向您发送登录KCC时的短信验证码、和/或找回密码时所需的短信验证码\n        "
                ),
                _c(
                  "span",
                  { staticStyle: { "font-style": "italic", padding: "8px 0" } },
                  [
                    _vm._v(
                      "（注：您的手机号码需被分享至腾讯云计算（北京）有限责任公司（“腾讯云”），由腾讯云通过其通讯资源合作伙伴提供腾讯云短信服务。若您对腾讯云如何处理手机号码有任何问题或意见，您可通过\n          "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href: "mailto:Dataprivacy@tencent.com",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Dataprivacy@tencent.com")]
                    ),
                    _vm._v("与其联系）"),
                  ]
                ),
                _vm._v("。\n      "),
              ]),
              _c("li", [
                _vm._v(
                  "对于与审计业务有关的文件传输，我方会收集您通过KCC向毕马威传输的审计相关文件当中可能包含的个人信息，此等文件用于毕马威根据其与您所在的公司（作为我方的审计客户）与毕马威签订的审计业务条款、提供审计服务。"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "\n        对于与非审计业务有关的文件传输，我方会收集您通过KCC向毕马威传输的非审计相关文件中可能包含的个人信息，此等文件用于毕马威根据其与您所在的公司（作为我方的非审计业务客户）与毕马威签订的非审计业务条款（或与您的公司有关联的第三方与毕马威订立的非审计业务条款）、提供非审计相关服务。\n      "
                ),
              ]),
            ]
          ),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      请注意，如果贵方不能提供上述个人信息，我方可能难以履行上述目的。\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      上述目的实现后，我方将根据适用法规保留、储存或销毁任何包含贵方个人信息的资料。在任何情况下，我方保留贵方个人信息的期限将不会超过实现目的所需或适用法规所允许的期限。\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      如果您需要向毕马威提供其他个人的个人信息，您需确认您已向相关人士告知其个人信息将被如何收集、使用、披露和转移，包括您向毕马威提供其个人信息、以及毕马威向第三方提供其个人信息（仅适用于非审计相关业务）的情况，且您已就此获得此等人士的授权和同意。\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      由于贵方向我方提供的前述个人信息当中可能会包含为实现上述目的所需的敏感个人信息，因此，我方需要贵方在此明确同意毕马威为上述目的收集和处理贵方个人信息。\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      贵方有权随时撤回贵方对我方以上述方式处理贵方个人信息的同意。贵方也可查阅、更正或查询我方保存的贵方个人信息。如果贵方希望行使上述权利，可发送请求至"
            ),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href: "mailto:cn-fmdataprivacy@kpmg.com",
                  target: "_blank",
                },
              },
              [_vm._v("cn-fmdataprivacy@kpmg.com")]
            ),
            _vm._v("或毕马威KCC支持团队\n      "),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href: "mailto:cnfmkpmgclicbt@kpmg.com",
                  target: "_blank",
                },
              },
              [_vm._v("cnfmkpmgclicbt@kpmg.com")]
            ),
            _vm._v("。\n    "),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "Notification and Consent Statement on Collection and Processing of Personal Information",
            visible: _vm.enPersonDialogVisible,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.enPersonDialogVisible = $event
            },
          },
        },
        [
          _vm._v(
            "\n    The personal information that KPMG receives from you for the purpose of KPMG providing you access to and\n    supporting\n    your use of KCC* (“Purpose”) are collected, used, processed and retained in accordance with the Personal\n    Information\n    Protection Law of the People’s Republic of China, Personal Data (Privacy) Ordinance of Hong Kong (SAR) and\n    Personal\n    Data Protection Act of Macau (SAR) (collectively “Applicable Laws”) and KPMG's\n    "
          ),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://kpmg.com/cn/en/home/misc/privacy.html",
                target: "_blank",
              },
            },
            [_vm._v(" Online Privacy Statement")]
          ),
          _vm._v("\n    and "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://assets.kpmg.com/content/dam/kpmg/cn/pdf/en/2023/03/kpmg-china-privacy-statement.pdf",
                target: "_blank",
              },
            },
            [_vm._v("KPMG China Privacy Statement")]
          ),
          _vm._v(" (collectively “Privacy Statement”).\n    "),
          _c(
            "ul",
            { staticStyle: { "font-style": "italic", padding: "8px 0" } },
            [
              _vm._v(
                "\n      (*KCC refers to KPMG Collaboration Centre. This Statement applies if you are an Authorised User as defined in\n      the\n      “KCC Terms of Use”; anything not stated herein regarding your access and use of KCC shall be subject to the\n      Terms of\n      Use).\n    "
              ),
            ]
          ),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      To serve the Purpose mentioned above, you hereby agree to provide KPMG with the following personal information:\n    "
            ),
          ]),
          _c(
            "ul",
            { staticStyle: { "list-style": "decimal", padding: "0 20px" } },
            [
              _c("li", [
                _vm._v(
                  "The following personal information will be required to enable KPMG to register you as a KCC user and to set\n        up a\n        KCC user access account for you.\n        "
                ),
                _c("p", [
                  _vm._v(
                    "(a) Your user name and work email address (to be used as KCC login account)."
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "(b) If you prefer, you may also choose to provide your mobile phone number, which will only be used to send\n          you\n          SMS verification code for log-in and/or for retrieving your password to KCC\n          "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: { "font-style": "italic", padding: "8px 0" },
                    },
                    [
                      _vm._v(
                        "(note: your mobile phone number will be shared with Tencent\n            Cloud\n            Computing (Beijing) Co., Ltd (“Tencent Cloud”) which provides Tencent SMS service via its telecom resource\n            partners; Tencent Cloud can be contacted via\n            "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: {
                            href: "mailto:Dataprivacy@tencent.com",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Dataprivacy@tencent.com")]
                      ),
                      _vm._v(
                        " if you\n            have\n            questions or comments to raise as to how it processes the phone number).\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _vm._v(
                  "For file transfers relating to audit engagements, personal information as may be contained in the audit\n        related\n        documents which you transfer to KPMG via KCC for KPMG to perform audit services pursuant to the audit\n        engagement\n        terms entered into by your company (being an audit client) with KPMG."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "For file transfers relating to non-audit engagements, personal information as may be contained in the\n        non-audit\n        related documents which you transfer to KPMG via KCC for KPMG to perform non-audit related services pursuant\n        to\n        the non-audit engagement terms entered into by your company (being a non-audit client) with KPMG or relating\n        to a\n        non-audit engagement entered into by a third party with KPMG in which your company is related to."
                ),
              ]),
            ]
          ),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      Please note that if you are not able to provide us with the above personal information, we may not be able to\n      carry\n      out the Purpose accordingly.\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      Once the above Purpose is achieved, any materials containing your personal information will be retained, stored,\n      or\n      destroyed in accordance with the Applicable Laws. In any event, your personal information will not be retained\n      longer than is necessary to achieve the Purpose or permitted by the Applicable Laws.\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      If you are required to provide personal information of other individuals to KPMG, you confirm that you have\n      informed\n      those individuals of the collection, use, disclosure and transfer of their personal information from you to KPMG\n      and\n      from KPMG to third parties (only applicable in the case of non-audit related engagements), and that you have\n      obtained those individuals’ authorisation and consent for you and KPMG to do so.\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      As the personal information you provide to KPMG may contain sensitive personal information as necessary for the\n      Purpose mentioned in the above, your explicit consent is therefore obtained for KPMG to collect and process such\n      personal information for the Purpose above.\n    "
            ),
          ]),
          _c("ul", { staticStyle: { padding: "8px 0" } }, [
            _vm._v(
              "\n      You have the right to withdraw your consent to the processing in the above manner at any time. You are also\n      entitled\n      to access, correct, or enquire about your personal information held by KPMG. If you wish to exercise your rights\n      aforementioned, you may do so by sending your request to "
            ),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href: "mailto:cn-fmdataprivacy@kpmg.com",
                  target: "_blank",
                },
              },
              [_vm._v("cn-fmdataprivacy@kpmg.com")]
            ),
            _vm._v(" or KPMG KCC Team "),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href: "mailto:cnfmkpmgclicbt@kpmg.com",
                  target: "_blank",
                },
              },
              [_vm._v("cnfmkpmgclicbt@kpmg.com")]
            ),
            _vm._v(".\n    "),
          ]),
        ]
      ),
      _vm.supportVisible
        ? _c("contact-us", {
            attrs: {
              onCancel: _vm.toogleSupportVisible,
              account: _vm.param.account,
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "video-player-cls",
          attrs: {
            title: "",
            visible: _vm.videoDisplay,
            "close-on-click-modal": false,
            "append-to-body": "",
            width: "600",
            "before-close": _vm.handleCloseVideo,
          },
          on: {
            "update:visible": function ($event) {
              _vm.videoDisplay = $event
            },
          },
        },
        [
          _vm.videoDisplay
            ? _c(
                "video",
                {
                  attrs: {
                    width: "100%",
                    controls: "",
                    oncontextmenu: "return false",
                    controlslist: "nodownload",
                    autoplay: "",
                  },
                },
                [
                  _c("source", {
                    attrs: { src: _vm.video, type: "video/mp4" },
                  }),
                  _vm._v("\n      您的浏览器不支持 video 标签。\n    "),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("set_session_title"),
            visible: _vm.setSessionVisible,
            width: "20%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setSessionVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("el-input-number", {
                attrs: { precision: 1, step: 0.5, max: 8, min: 0.5 },
                model: {
                  value: _vm.outTime,
                  callback: function ($$v) {
                    _vm.outTime = $$v
                  },
                  expression: "outTime",
                },
              }),
              _vm._v("\n      " + _vm._s(_vm.$t("hour")) + "\n      "),
              _c(
                "div",
                {
                  staticClass: "tip",
                  staticStyle: { color: "#fd349c", "text-align": "left" },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("outTimeTips")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setOutTime } },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }